import type React from 'react';

export const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    inset: 0,
    zIndex: 100000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(0, 0, 0, 0.55)',
    padding: 24,
};

export const panelStyle: React.CSSProperties = {
    width: 'min(720px, 100%)',
    maxHeight: '88vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#16161a',
    color: '#f4f4f5',
    border: '1px solid #2e2e35',
    borderRadius: 12,
    boxShadow: '0 24px 64px rgba(0, 0, 0, 0.45)',
    overflow: 'hidden',
    fontFamily: 'ui-sans-serif, system-ui, sans-serif',
};

export const headerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '14px 16px',
    borderBottom: '1px solid #2e2e35',
};

export const titleStyle: React.CSSProperties = {
    margin: 0,
    fontSize: 15,
    fontWeight: 650,
    letterSpacing: 0.2,
};

export const closeButtonStyle: React.CSSProperties = {
    cursor: 'pointer',
    border: '1px solid #3f3f46',
    background: 'transparent',
    color: '#f4f4f5',
    borderRadius: 6,
    padding: '6px 10px',
    fontSize: 13,
};

export const tabsStyle: React.CSSProperties = {
    display: 'flex',
    gap: 4,
    padding: '0 16px',
    borderBottom: '1px solid #2e2e35',
};

export const tabStyle: React.CSSProperties = {
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    color: '#a1a1aa',
    padding: '10px 12px',
    fontSize: 13,
    fontWeight: 600,
    borderBottom: '2px solid transparent',
};

export const tabActiveStyle: React.CSSProperties = {
    ...tabStyle,
    color: '#f4f4f5',
    borderBottom: '2px solid #60a5fa',
};

export const bodyStyle: React.CSSProperties = {
    padding: 16,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
};

export const fieldStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    textAlign: 'left',
};

export const fieldLabelStyle: React.CSSProperties = {
    fontSize: 12,
    fontWeight: 650,
    color: '#d4d4d8',
};

export const textareaStyle: React.CSSProperties = {
    width: '100%',
    minHeight: 112,
    resize: 'vertical',
    boxSizing: 'border-box',
    padding: 10,
    borderRadius: 8,
    border: '1px solid #3f3f46',
    background: '#0e0e11',
    color: '#e4e4e7',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: 12,
    lineHeight: 1.45,
};

export const errorStyle: React.CSSProperties = {
    margin: 0,
    color: '#fca5a5',
    fontSize: 13,
};

export const actionsStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    padding: '12px 16px',
    borderTop: '1px solid #2e2e35',
};

export const secondaryButtonStyle: React.CSSProperties = {
    cursor: 'pointer',
    border: '1px solid #3f3f46',
    background: 'transparent',
    color: '#e4e4e7',
    borderRadius: 6,
    padding: '8px 14px',
    fontSize: 13,
    fontWeight: 600,
};

export const dangerButtonStyle: React.CSSProperties = {
    ...secondaryButtonStyle,
    color: '#fca5a5',
    borderColor: '#7f1d1d',
};

export const primaryButtonStyle: React.CSSProperties = {
    ...secondaryButtonStyle,
    background: '#2563eb',
    borderColor: '#2563eb',
    color: '#fff',
};

export const fontListStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 420,
    overflowY: 'auto',
    border: '1px solid #3f3f46',
    borderRadius: 8,
    background: '#0e0e11',
};

export const fontRowStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px 12px',
    borderBottom: '1px solid #27272a',
};

export const fontNameStyle: React.CSSProperties = {
    minWidth: 170,
    fontSize: 12,
    color: '#a1a1aa',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
};

export const fontSampleStyle: React.CSSProperties = {
    fontSize: 18,
    color: '#f4f4f5',
};

export const fontStatusStyle: React.CSSProperties = {
    width: 20,
    flexShrink: 0,
    fontSize: 16,
    lineHeight: '20px',
    textAlign: 'center',
};
